export const TablePaperStyle = {
  borderRadius: "2%",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  paddingBottom: "1rem",
  width: "100%",
};
